

// 音频索引与展示节点的映射（多段音频播放模式）
// 节点1 音频1-6 
// 节点2 音频7 
// 节点3 音频8-43 
// 节点4 音频44-46 
// 节点5 音频47-48 
// 节点6 音频49-54 
// 节点7 音频55-56 
// 节点8 音频57-62 
// 节点9 音频63-64 
// 节点10 音频65-70 
// 节点11 音频71-72 
// 节点12 音频73-78 
// 节点13 音频79-80 
// 节点14 音频81-93
export const audioNodeMapping = [
  // 节点1: 音频1-6 (片头部分)
  { audioIdx: 0, node: 1,  indicateType: 1 },   // 开头14秒
  { audioIdx: 1, node: 1,  indicateType: 1 },   // 1秒空白
  { audioIdx: 2, node: 1,  indicateType: 1 },   // 英语听力模拟试题
  { audioIdx: 3, node: 1,  indicateType: 1 },   // 0.200秒空白
  { audioIdx: 4, node: 1,  indicateType: 1 },   // 题目数字
  { audioIdx: 5, node: 1,  indicateType: 1 },   // 1.500秒空白
  
  // 节点2: 音频7 (第一节旁白)
  { audioIdx: 6, node: 2,  indicateType: 1 },   // 第一节-标准模拟题
  
  // 节点3: 音频8-43 (第一节5段材料)
  { audioIdx: 7, node: 3,  indicateType: 2 },   // 5秒空白
  { audioIdx: 8, node: 3,  indicateType: 1 },   // 标准叮咚3秒
  { audioIdx: 9, node: 3,  indicateType: 1 },   // 听下面的录音，回答第1小题
  { audioIdx: 10, node: 3,  indicateType: 1 },  // 1.5秒空白
  { audioIdx: 11, node: 3,  indicateType: 2 },  // Text1-01
  { audioIdx: 12, node: 3,  indicateType: 0 },  // 2秒空白
  { audioIdx: 13, node: 3,  indicateType: 2 },  // Text1-02
  { audioIdx: 14, node: 3,  indicateType: 2 },  // 10秒空白
  { audioIdx: 15, node: 3,  indicateType: 1 },  // 标准叮咚3秒
  { audioIdx: 16, node: 3,  indicateType: 1 },  // 听下面的录音，回答第2小题
  { audioIdx: 17, node: 3,  indicateType: 1 },  // 1.5秒空白
  { audioIdx: 18, node: 3,  indicateType: 2 },  // Text2-01
  { audioIdx: 19, node: 3,  indicateType: 0 },  // 2秒空白
  { audioIdx: 20, node: 3,  indicateType: 2 },  // Text2-02
  { audioIdx: 21, node: 3,  indicateType: 2 },  // 10秒空白
  { audioIdx: 22, node: 3,  indicateType: 1 },  // 标准叮咚3秒
  { audioIdx: 23, node: 3,  indicateType: 1 },  // 听下面的录音，回答第3小题
  { audioIdx: 24, node: 3,  indicateType: 1 },  // 1.5秒空白
  { audioIdx: 25, node: 3,  indicateType: 2 },  // Text3-01
  { audioIdx: 26, node: 3,  indicateType: 0 },  // 2秒空白
  { audioIdx: 27, node: 3,  indicateType: 2 },  // Text3-02
  { audioIdx: 28, node: 3,  indicateType: 2 },  // 10秒空白
  { audioIdx: 29, node: 3,  indicateType: 1 },  // 标准叮咚3秒
  { audioIdx: 30, node: 3,  indicateType: 1 },  // 听下面的录音，回答第4小题
  { audioIdx: 31, node: 3,  indicateType: 1 },  // 1.5秒空白
  { audioIdx: 32, node: 3,  indicateType: 2 },  // Text4-01
  { audioIdx: 33, node: 3,  indicateType: 0 },  // 2秒空白
  { audioIdx: 34, node: 3,  indicateType: 2 },  // Text4-02
  { audioIdx: 35, node: 3,  indicateType: 2 },  // 10秒空白
  { audioIdx: 36, node: 3,  indicateType: 1 },  // 标准叮咚3秒
  { audioIdx: 37, node: 3,  indicateType: 1 },  // 听下面的录音，回答第5小题
  { audioIdx: 38, node: 3,  indicateType: 1 },  // 1.5秒空白
  { audioIdx: 39, node: 3,  indicateType: 2 },  // Text5-01
  { audioIdx: 40, node: 3,  indicateType: 0 },  // 2秒空白
  { audioIdx: 41, node: 3,  indicateType: 2 },  // Text5-02
  { audioIdx: 42, node: 3,  indicateType: 2 },  // 5秒空白
  
  // 节点4: 音频44-46 (第二节旁白)
  { audioIdx: 43, node: 4,  indicateType: 1 },  // 标准叮咚3秒
  { audioIdx: 44, node: 4,  indicateType: 1 },  // 第二节（5段录音）-标准模拟题
  { audioIdx: 45, node: 4,  indicateType: 1 },  // 2秒空白
  
  // 节点5: 音频47-48 (材料6旁白)
  { audioIdx: 46, node: 5,  indicateType: 1 },  // 标准叮咚3秒
  { audioIdx: 47, node: 5,  indicateType: 1 },  // Text6-录音回答2题（6-7）
  
  // 节点6: 音频49-54 (材料6)
  { audioIdx: 48, node: 6,  indicateType: 2 },  // 10秒空白
  { audioIdx: 49, node: 6,  indicateType: 0 },  // 标准叮咚3秒
  { audioIdx: 50, node: 6,  indicateType: 2 },  // Text6-01
  { audioIdx: 51, node: 6,  indicateType: 0 },  // 2秒空白
  { audioIdx: 52, node: 6,  indicateType: 2 },  // Text6-02
  { audioIdx: 53, node: 6,  indicateType: 2 },  // 10秒空白
  
  // 节点7: 音频55-56 (材料7旁白)
  { audioIdx: 54, node: 7,  indicateType: 1 },  // 标准叮咚3秒
  { audioIdx: 55, node: 7,  indicateType: 1 },  // Text7-录音回答2题（8-9）
  
  // 节点8: 音频57-62 (材料7)
  { audioIdx: 56, node: 8,  indicateType: 2 },  // 10秒空白
  { audioIdx: 57, node: 8,  indicateType: 0 },  // 标准叮咚3秒
  { audioIdx: 58, node: 8,  indicateType: 2 },  // Text7-01
  { audioIdx: 59, node: 8,  indicateType: 0 },  // 2秒空白
  { audioIdx: 60, node: 8,  indicateType: 2 },  // Text7-02
  { audioIdx: 61, node: 8,  indicateType: 2 },  // 10秒空白
  
  // 节点9: 音频63-64 (材料8旁白)
  { audioIdx: 62, node: 9,  indicateType: 1 },  // 标准叮咚3秒
  { audioIdx: 63, node: 9,  indicateType: 1 },  // Text8-录音回答3题（10-12）
  
  // 节点10: 音频65-70 (材料8)
  { audioIdx: 64, node: 10,  indicateType: 2 }, // 15秒空白
  { audioIdx: 65, node: 10,  indicateType: 0 }, // 标准叮咚3秒
  { audioIdx: 66, node: 10,  indicateType: 2 }, // Text8-01
  { audioIdx: 67, node: 10,  indicateType: 0 }, // 2秒空白
  { audioIdx: 68, node: 10,  indicateType: 2 }, // Text8-02
  { audioIdx: 69, node: 10,  indicateType: 2 }, // 15秒空白
  
  // 节点11: 音频71-72 (材料9旁白)
  { audioIdx: 70, node: 11,  indicateType: 1 }, // 标准叮咚3秒
  { audioIdx: 71, node: 11,  indicateType: 1 }, // Text9-录音回答4题（13-16）
  
  // 节点12: 音频73-78 (材料9)
  { audioIdx: 72, node: 12,  indicateType: 2 }, // 20秒空白
  { audioIdx: 73, node: 12,  indicateType: 0 }, // 标准叮咚3秒
  { audioIdx: 74, node: 12,  indicateType: 2 }, // Text9-01
  { audioIdx: 75, node: 12,  indicateType: 0 }, // 2秒空白
  { audioIdx: 76, node: 12,  indicateType: 2 }, // Text9-02
  { audioIdx: 77, node: 12,  indicateType: 2 }, // 20秒空白
  
  // 节点13: 音频79-80 (材料10旁白)
  { audioIdx: 78, node: 13,  indicateType: 1 }, // 标准叮咚3秒
  { audioIdx: 79, node: 13,  indicateType: 1 }, // Text10-录音回答4题（17-20）
  
  // 节点14: 音频81-93 (材料10及结束)
  { audioIdx: 80, node: 14,  indicateType: 2 }, // 20秒空白
  { audioIdx: 81, node: 14,  indicateType: 0 }, // 标准叮咚3秒
  { audioIdx: 82, node: 14,  indicateType: 2 }, // Text10-01
  { audioIdx: 83, node: 14,  indicateType: 0 }, // 2秒空白
  { audioIdx: 84, node: 14,  indicateType: 2 }, // Text10-02
  { audioIdx: 85, node: 14,  indicateType: 2 }, // 20秒空白
  { audioIdx: 86, node: 14,  indicateType: 1 }, // 标准叮咚3秒
  { audioIdx: 87, node: 14,  indicateType: 1 }, // 第二节结束，2分钟转涂答题卡
  { audioIdx: 88, node: 14,  indicateType: 2 }, // 2分钟空白
  { audioIdx: 89, node: 14,  indicateType: 1 }, // 标准叮咚3秒
  { audioIdx: 90, node: 14,  indicateType: 1 }, // 听力部分到此结束
  { audioIdx: 91, node: 14,  indicateType: 1 }, // 1秒空白
  { audioIdx: 92, node: 14,  indicateType: 2 }, // 结尾音乐
]

